module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAtUlEQVQ4T+3TuxECIRAG4CXa1FLsQEuQbMm0BDqwE2NIKEFL0Q5MSVjnZs4bhuPlSHiEDHwD/+4KGLzEYA828P9ElwyNMSdmPhCR7mGdczvv/Y2ZtVLq+b2zgNbafQjhAQCOiC41dMbuACAQ8SilfK/AaaMHrWGTsWqbGtrCsmDppT1YEUxRRNTe+2xmadbVSYm+zwDwSguQK1xz9Gb0iojnuJqlLmiCPT0Zn9nAXxNbnx+e4QfC93EVYzuvtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_.png
// module id = z76h
// module chunks = 1